export default "__VITE_ASSET__BpLu1Jlp__"